import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconFilterOpen: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <path
        d="M4.21429 10.5161V2H2.78571V10.5161H1L3.5 13L6 10.5161H4.21429Z"
        fill={fill}
      />
      <path d="M7 11H16V13H7V11Z" fill={fill} />
      <path d="M7 8H14V10H7V8Z" fill={fill} />
      <path d="M7 5H12V7H7V5Z" fill={fill} />
      <path d="M7 2H10V4H7V2Z" fill={fill} />
    </Icon>
  );
};

export default IconFilterOpen;
